<template>
  <div class="profile-basic-details">
    <SectionThreeItemsHeader class="mb-6">
      <template v-slot:item-center>
        <h2>Basic Details</h2>
      </template>
      <template v-slot:item-right>
        <EditBasicDetailsAction />
      </template>
    </SectionThreeItemsHeader>
    <Permissioned section="workers.edit" vertical>
      <LabeledText label="Name" :permission="permissions.name">
        {{ userData | fullName }}
      </LabeledText>
      <LabeledText label="Email Address" :permission="permissions.email">
        {{ userData.email }}
      </LabeledText>
      <LabeledText label="Password" :permission="permissions.password">
        <div class="hidden-text" />
      </LabeledText>
    </Permissioned>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import Permissioned from "@/components/common/Permissioned";
import SectionThreeItemsHeader from "@/components/common/SectionThreeItemsHeader/SectionThreeItemsHeader";
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import EditBasicDetailsAction from "@/views/settings/components/actions/EditBasicDetailsAction";
import { PERMISSIONS } from "@/constants/workers";

const { mapState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  components: {
    LabeledText,
    Permissioned,
    EditBasicDetailsAction,
    SectionThreeItemsHeader
  },
  data() {
    return {
      permissions: PERMISSIONS.BASIC_DETAILS
    };
  },
  computed: {
    ...mapState({
      userData: state => state.userData
    })
  }
};
</script>
